import * as Enums from '@xbs/xbs-enums';

export class EnumsWithTranslationsConstants {
  public static readonly PRIMARY_FUNCTIONS = {
    DISTRIBUTOR: { ...Enums.PrimaryFunctions.ByName.Distributor, Value: 'primary_functions.distributor' },
    SERVICE_PROVIDER: { ...Enums.PrimaryFunctions.ByName.ServiceProvider, Value: 'primary_functions.service_provider' },
  };

  public static readonly FUNCTIONS_PERFORMED = {
    DOES_NOT_HAVE_VALUE_ADDED: { ...Enums.FunctionsPerformed.ByName.DoesNotHaveValueAdded, Value: 'function_performed.non_value_added_distributor' },
    HAS_VALUE_ADDED: { ...Enums.FunctionsPerformed.ByName.HasValueAdded, Value: 'function_performed.value_added_distributor' },
  };
}
